export interface IEditStockLoacationReturnDate {
    stock_location_id: string;
    date_returned: string;
}
